import { Observable } from 'rxjs';

import { AppConfigInterface } from './app-config.interface';
import { AppConfigService } from './app-config.service';

export function initializeAppFactory(appConfigService: AppConfigService): () => Observable<AppConfigInterface | null> {
    return () => appConfigService.init$();
}
